import { useQuery } from 'react-query';
import Logo from '../../assets/images/brand/new_logo_foreground.webp';
import { Categories } from './components/categories';
import { Feed } from './components/feed';
import { getNewsCategories, getNewsFeed } from '../../core';
import { useState } from 'react';
import { CustomLoader } from '../../components/basic/loader';

export const Home = () => {
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const feedQuery = useQuery({
    queryKey: ['feed', selectedCategory],
    queryFn: async () => {
      if (selectedCategory) {
        const res = await getNewsFeed(selectedCategory, 1);
        return res.data.data;
      }
      return null;
    }
  });

  const categoriesQuery = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const res = await getNewsCategories();
      if (!selectedCategory) {
        setSelectedCategory(res.data[0].id);
      }
      return res.data;
    },
    onSuccess: () => {
      feedQuery.refetch();
    }
  });

  const handleChangeCategory = (newCategoryId: number) => {
    setSelectedCategory(newCategoryId);
  };

  return (
    <>
      <div className="flex flex-row items-center pt-1.5 pr-1.5 mb-4">
        <span className="w-[72px] rounded-[1000px] overflow-hidden">
          <img style={{ transform: 'scale(1.5)' }} src={Logo} alt="MedMe logo" />
        </span>
        <p className="text-center mr-4">
          مدمی | MedMe
          <br />
          تشخیص و آموزش تخصصی پزشکی
        </p>
      </div>
      {!categoriesQuery.isLoading ? (
        <Categories
          categories={categoriesQuery.data}
          onSelectCategory={handleChangeCategory}
          selectedCategory={selectedCategory}
        />
      ) : (
        <CustomLoader />
      )}
      {!feedQuery.isLoading ? <Feed feed={feedQuery.data} /> : <CustomLoader />}
    </>
  );
};
